export const downloadPdf = async (url, filename) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Não foi possível obter o PDF.');
  const data = await response.arrayBuffer();
  const header = String.fromCharCode(...new Uint8Array(data.slice(0, 5)));
  if (header !== '%PDF-') throw new Error('O endereço não retornou um PDF.');

  const objectUrl = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Give browsers enough time to consume the URL before releasing it.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
};
